// Libraries
import get from 'lodash/get';

// Utils
import { escapeQuery } from '@/utils/regex';
import { formatLocalizedString } from './i18n';

const getFuzzyRegExp = (q: string) => new RegExp(`.*${Array.from(q).map(escapeQuery).join('.*')}.*`, 'i');
const getPreciseRegExp = (q: string) => new RegExp(`${escapeQuery(q)}`, 'i');

export const searchObjectsOnFields = (query: string, objects: any[], fields: string | string[], fuzzy = true) => {
  const searchableFields = Array.isArray(fields) ? fields : [fields];

  // Split query into characters, then escape each of them individually.
  const regex = fuzzy ? getFuzzyRegExp(query) : getPreciseRegExp(query);

  return objects.filter((o: any) => searchableFields.some(field => regex.test(getValue(o, field).toString())));
};

const getValue = (object: any, field: string) => {
  const value = get(object, field, '');
  return typeof value === 'object' ? formatLocalizedString(value) : value;
};
